import React from "react";

import { Button, NumberLabel } from "aible";
import Select from "react-select";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp, faArrowDown } from "@fortawesome/free-solid-svg-icons";

import DeploymentItem from "containers/View/Item/DeploymentItem";

import { isEnabled } from "utils/featureFlags";

import styles from "./style.module.css";

function isScrolledIntoView(el) {
  var rect = el.getBoundingClientRect();
  var elemTop = rect.top;
  var elemBottom = rect.bottom;

  // Only completely visible elements return true:
  var isVisible = elemTop >= 0 && elemBottom <= 300;
  // Partially visible elements return true:
  //isVisible = elemTop < window.innerHeight && elemBottom >= 0;
  return isVisible;
}

function shouldSectionScroll(el) {
  var sectionOffset = el.offsetTop;
  var scrollOffset = document.getElementById("wizardScroll")
    ? document.getElementById("wizardScroll").scrollTop
    : undefined;

  return scrollOffset ? sectionOffset - scrollOffset > 0 : false;
}

export default class SuccessResults extends React.PureComponent {
  constructor(props) {
    super(props);

    if (window.tableau) {
      const markSelection = window.tableau.TableauEventType.MarkSelectionChanged;

      window.tableau.extensions.initializeDialogAsync().then(() => {
        const dashboard = window.tableau.extensions.dashboardContent.dashboard;

        for (const worksheet of dashboard.worksheets) {
          const unregisterEventHandlerFunction = worksheet.addEventListener(markSelection, (selectionEvent) => {
            worksheet.getSelectedMarksAsync().then((marks) => {
              let colName = undefined;
              let index = 0;
              let foundIndex = undefined;

              const fieldNames = props.fieldNames;

              if (
                fieldNames &&
                marks.data &&
                marks.data.length > 0 &&
                marks.data[0].columns &&
                marks.data[0].columns.length > 0
              ) {
                for (const col of marks.data[0].columns) {
                  const tempColName = col.fieldName.replace(" (bin)", "");

                  if (fieldNames.indexOf(col.fieldName) !== -1) {
                    foundIndex = index;
                    colName = col.fieldName;
                    props.updateFieldSelect(colName);

                    document.getElementById("wizardScroll") &&
                      document.getElementById("section_" + "Success") &&
                      shouldSectionScroll(document.getElementById("section_" + "Success")) &&
                      document.getElementById("wizardScroll").scrollTo({
                        top: document.getElementById("section_" + "Success").offsetTop + 80,
                        behavior: "smooth"
                      });

                    document.getElementById("featureChart") &&
                      document.getElementById(colName) &&
                      isScrolledIntoView(document.getElementById(colName)) === false &&
                      document.getElementById("featureChart").firstElementChild.firstElementChild.scrollTo({
                        top: document.getElementById(colName).offsetTop,
                        behavior: "smooth"
                      });
                  }

                  index++;
                }

                if (foundIndex !== undefined) {
                  const valName =
                    marks.data &&
                    marks.data.length > 0 &&
                    marks.data[0].data &&
                    marks.data[0].data.length > 0 &&
                    marks.data[0].data[0].length > 0
                      ? marks.data[0].data[0][foundIndex].value
                      : undefined;

                  if (
                    marks.data &&
                    marks.data.length > 0 &&
                    marks.data[0].data &&
                    marks.data[0].data.length > 0 &&
                    marks.data[0].data.length < 5 &&
                    marks.data[0].data[0].length > 1
                  ) {
                    if (valName !== undefined) {
                      if (
                        props.selectedDataset &&
                        props.selectedDataset.fields &&
                        props.selectedDataset.fields[colName] &&
                        props.selectedDataset.fields[colName].type === "categorical"
                      ) {
                        if (props.selectedDataset.fields[colName].data?.map((v) => v.value).indexOf(valName) !== -1) {
                          props.updateValueSelect(valName);
                        }
                      } else {
                        props.updateValueSelect(undefined);
                      }
                    }
                  } else {
                    props.updateValueSelect(undefined);
                  }
                }
              }
            });
          });
        }
      });
    }
  }

  state = {
    showGraph: false,
    boxItem: undefined,
    isNextStep: false
  };

  renderModelOptions() {
    const { id, models, model, isWinner, isContinuous, isQuickRun, chooseModelTile, chooseModel, updateChooseModel } =
      this.props;

    return (
      <div className={styles.modelOptions}>
        <div className={styles.options}>
          <div className={styles.optionHolder}>
            <Select
              options={models.map((m) => ({ value: m.id, label: m.id }))}
              value={chooseModel ? chooseModel : { value: model.id, label: model.id }}
              onChange={(val) => updateChooseModel(val.value)}
              styles={{
                menu: (provided) => ({
                  ...provided,
                  zIndex: 100
                })
              }}
            />
          </div>
          {isQuickRun !== true && model.id !== "Current State" && (
            <div className={styles.optionText}>
              {isWinner
                ? "won " +
                  (isContinuous ? "" : "by ROI") +
                  " over " +
                  (models.length - (isContinuous ? 1 : 2)) +
                  " other models"
                : model.index +
                  1 +
                  " of " +
                  (isContinuous ? models.length : models.length - 1) +
                  (isContinuous ? " by ROI" : "")}
            </div>
          )}
        </div>
      </div>
    );
  }

  renderSmallImprovement() {
    const { model, models, runPlot, netImpactLabel, isContinuous } = this.props;
    const { showGraph } = this.state;

    const currentState =
      models.filter((m) => m.id === "Current State").length > 0
        ? models.filter((m) => m.id === "Current State")[0]
        : undefined;
    const secondBest = models && models.length > 1 ? (models[0].id === model.id ? models[1] : models[0]) : undefined;

    const numberFormatParams = {
      shortFormat: true,
      shortFormatMinValue: 0,
      precision: 1
    };

    return (
      <div
        className={styles.infoBox + " " + styles.fLargest + " " + styles.bSmall}
        style={isContinuous ? { width: "auto" } : {}}
      >
        <div className={styles.infoTop}>
          {model && model.maxIteration ? (
            <div className={styles.infoFlex}>
              {model.maxIteration.displayImpact < 0 && !isContinuous && <span>{"-"}</span>}
              <NumberLabel params={numberFormatParams}>
                {isContinuous
                  ? Math.round(Math.abs(model.checkMax))
                  : Math.round(Math.abs(model.maxIteration.displayImpact))}
              </NumberLabel>
            </div>
          ) : (
            ""
          )}
        </div>
        <div
          className={styles.infoBottom + " " + styles.fMedium + " " + styles.bFix}
          style={{
            padding: "0px",
            paddingLeft: "5px",
            paddingRight: "5px"
          }}
        >
          {isContinuous ? "Total Cost" : netImpactLabel}
        </div>
      </div>
    );
  }

  renderImprovement() {
    const { model, models, runPlot, netImpactLabel, isContinuous } = this.props;
    const { showGraph } = this.state;

    const currentState =
      models.filter((m) => m.id === "Current State").length > 0
        ? models.filter((m) => m.id === "Current State")[0]
        : undefined;
    const secondBest = models && models.length > 1 ? (models[0].id === model.id ? models[1] : models[0]) : undefined;

    const numberFormatParams = {
      shortFormat: true,
      shortFormatMinValue: 0,
      precision: 1
    };

    return (
      <div>
        <div className={styles.improve}>
          {model && currentState && (
            <div className={styles.infoBox + " " + styles.fMedium + " " + styles.bLarge}>
              <div className={styles.infoTop}>
                {currentState ? (
                  <div className={styles.infoFlex}>
                    <NumberLabel params={numberFormatParams}>
                      {Math.round(Math.abs(model.maxIteration.displayImpact - currentState.maxIteration.displayImpact))}
                    </NumberLabel>
                  </div>
                ) : (
                  ""
                )}
                <FontAwesomeIcon
                  icon={
                    currentState && model.maxIteration.displayImpact - currentState.maxIteration.displayImpact >= 0
                      ? faArrowUp
                      : faArrowDown
                  }
                  className={
                    currentState && model.maxIteration.displayImpact - currentState.maxIteration.displayImpact >= 0
                      ? styles.good
                      : styles.bad
                  }
                  style={{ marginLeft: "5px", marginRight: "5px" }}
                />
                <span className={styles.infoSecondText + " " + styles.fMedium + " " + styles.wrap}>
                  {currentState && model.maxIteration.displayImpact - currentState.maxIteration.displayImpact >= 0
                    ? "More than"
                    : "Less than"}
                </span>
              </div>
              <div
                className={styles.infoBottom + " " + styles.bFix}
                style={{
                  padding: "0px",
                  paddingLeft: "5px",
                  paddingRight: "5px"
                }}
              >
                {"Current state"}
              </div>
            </div>
          )}
          <div
            className={styles.infoBox + " " + styles.fLargest + " " + styles.bSmall}
            style={isContinuous ? { width: "auto" } : {}}
          >
            <div className={styles.infoTop}>
              {model && model.maxIteration ? (
                <div className={styles.infoFlex}>
                  {model.maxIteration.displayImpact < 0 && !isContinuous && <span>{"-"}</span>}
                  <NumberLabel params={numberFormatParams}>
                    {isContinuous
                      ? Math.round(Math.abs(model.checkMax))
                      : Math.round(Math.abs(model.maxIteration.displayImpact))}
                  </NumberLabel>
                </div>
              ) : (
                ""
              )}
            </div>
            <div
              className={styles.infoBottom + " " + styles.fMedium + " " + styles.bFix}
              style={{
                padding: "0px",
                paddingLeft: "5px",
                paddingRight: "5px"
              }}
            >
              {isContinuous ? "Total Cost" : netImpactLabel}
            </div>
          </div>
          <div className={styles.infoBox + " " + styles.fMedium + " " + styles.bLarge}>
            <div className={styles.infoTop}>
              {secondBest ? (
                <div className={styles.infoFlex}>
                  <NumberLabel params={numberFormatParams}>
                    {isContinuous
                      ? Math.round(Math.abs(model.checkMax - secondBest.checkMax))
                      : Math.round(Math.abs(model.maxIteration.displayImpact - secondBest.maxIteration.displayImpact))}
                  </NumberLabel>
                </div>
              ) : (
                ""
              )}
              <FontAwesomeIcon
                icon={
                  secondBest && model.maxIteration.displayImpact - secondBest.maxIteration.displayImpact >= 0
                    ? faArrowUp
                    : faArrowDown
                }
                className={
                  secondBest && model.maxIteration.displayImpact - secondBest.maxIteration.displayImpact >= 0
                    ? isContinuous
                      ? styles.bad
                      : styles.good
                    : isContinuous
                      ? styles.good
                      : styles.bad
                }
                style={{ marginLeft: "5px", marginRight: "5px" }}
              />
              <span className={styles.infoSecondText + " " + styles.fMedium + " " + styles.wrap}>
                {secondBest && model.maxIteration.displayImpact - secondBest.maxIteration.displayImpact >= 0
                  ? "More than"
                  : "Less than"}
              </span>
            </div>
            <div
              className={styles.infoBottom + " " + styles.bFix}
              style={{
                padding: "0px",
                paddingLeft: "5px",
                paddingRight: "5px"
              }}
            >
              {models[0].id === model.id ? "Second best AI" : "Best AI"}
            </div>
          </div>
        </div>
      </div>
    );
  }

  handleUpdateImpact(impactType, impact, id) {
    const { updateImpact, updateChooseModel } = this.props;

    return updateImpact(impactType, impact);
  }

  handleProcessUpdate(processLimit) {
    const { updateProcessLimit } = this.props;

    document.getElementById("wizardScroll") &&
      document.getElementById("section_Contest") &&
      document.getElementById("wizardScroll").scrollTo({
        top: document.getElementById("section_Contest").offsetTop - 175,
        behavior: "smooth"
      });

    return setTimeout(() => updateProcessLimit(processLimit), 1500);
  }

  renderNext() {
    const {
      model,
      models,
      labels,
      isDefaultImpacts,
      isTwoMinuteRun,
      processLimit,
      resetDefaults,
      updateImpact,
      updateProcessLimit
    } = this.props;

    const processed = model && model.maxIteration ? Math.round((1 - model.maxIteration.processed) * 100) : undefined;

    const processMissed = model && model.maxIteration ? model.maxIteration.processMissed : undefined;

    const color = processMissed < -0.01 ? "rgba(235, 51, 43)" : "rgb(146, 207, 72)";
    const border = processMissed < -0.01 ? "1px solid rgb(235, 51, 43)" : "1px solid rgb(78, 134, 10)";

    let closestModel = undefined;
    for (const switchType in model.changeList) {
      const m = model.changeList[switchType] ? model.changeList[switchType] : undefined;

      if (m !== undefined && m.close !== undefined && (closestModel === undefined || m.close < closestModel.close)) {
        closestModel = m;
      }
    }

    if (closestModel === undefined || isTwoMinuteRun) {
      return <div />;
    }

    const isGoodAssumption = Math.abs(closestModel.closeRatio) > 0.5;
    const isOKAssumption =
      (Math.abs(closestModel.closeRatio) > 0.1 && Math.abs(closestModel.closeRatio) < 0.5) || !isDefaultImpacts;

    return (
      <div className={styles.nextHolder}>
        <div
          className={
            styles.nextBox +
            " " +
            (isGoodAssumption ? styles.goodBox : isOKAssumption ? styles.orangeBox : styles.badBox)
          }
        >
          <div
            className={styles.boxTitle + " " + styles.fMedium}
            style={{
              color: isGoodAssumption ? "rgb(146, 207, 72)" : isOKAssumption ? "#eaa742" : "rgb(235, 51, 43)"
            }}
          >
            {"Assumption Double Check"}
          </div>
          <div className={styles.botHolder}>
            <div className={styles.infoBox + " " + styles.fLarge + " " + styles.bMedium}>
              <div
                className={styles.infoTop}
                style={{
                  color: isGoodAssumption ? "rgb(146, 207, 72)" : isOKAssumption ? "#eaa742" : "rgb(235, 51, 43)"
                }}
              >
                {"If " +
                  (Math.abs(closestModel.closeRatio) < 2.5
                    ? Math.round(Math.abs(closestModel.closeRatio * 100)) + "%"
                    : Math.round(Math.abs(closestModel.closeRatio)) + "x")}
                <FontAwesomeIcon
                  icon={closestModel.impact > 0 ? faArrowUp : faArrowDown}
                  className={closestModel.impact > 0 ? styles.good : styles.bad}
                  style={{ marginLeft: "5px", marginRight: "5px" }}
                />
                <span className={styles.infoSecondText + " " + styles.fSmall}>
                  {closestModel.impact > 0 ? (
                    <div>
                      <div>{"Higher"}</div>
                      <div>{"benefit of"}</div>
                    </div>
                  ) : (
                    <div>
                      <div>{"Lower"}</div>
                      <div>{"cost of"}</div>
                    </div>
                  )}
                </span>
              </div>
              <div
                className={styles.infoBottom + " " + styles.fMedium}
                style={
                  isGoodAssumption
                    ? {
                        background: "rgb(146, 207, 72)",
                        border: "1px solid rgb(146, 207, 72)"
                      }
                    : isOKAssumption
                      ? { background: "#eaa742", border: "1px solid #a26200" }
                      : {
                          background: "rgb(235, 51, 43)",
                          border: "1px solid rgb(235, 51, 43)"
                        }
                }
              >
                {closestModel.type}
              </div>
            </div>
            <div className={styles.infoBox + " " + styles.fLarge + " " + styles.bMedium}>
              <div
                className={styles.infoTop + " " + styles.fMedium}
                style={{
                  color: isGoodAssumption ? "rgb(146, 207, 72)" : isOKAssumption ? "#eaa742" : "rgb(235, 51, 43)"
                }}
              >
                {"New winner would be"}
              </div>
              <div
                className={styles.infoBottom + " " + styles.fMedium + " " + styles.overflow}
                style={
                  isGoodAssumption
                    ? {
                        background: "rgb(146, 207, 72)",
                        border: "1px solid rgb(146, 207, 72)"
                      }
                    : isOKAssumption
                      ? { background: "#eaa742", border: "1px solid #a26200" }
                      : {
                          background: "rgb(235, 51, 43)",
                          border: "1px solid rgb(235, 51, 43)"
                        }
                }
                title={closestModel.model.id}
              >
                {closestModel.model.id}
              </div>
            </div>
          </div>
        </div>
        <div
          className={styles.processingBox + " " + (processMissed < -0.01 ? styles.badBox : styles.goodBox)}
          onClick={() => this.handleProcessUpdate(model.maxIteration.bestResource)}
        >
          <div className={styles.boxTitle + " " + styles.fMedium} style={{ color: color }}>
            {"Operating Resources"}
          </div>
          <div className={styles.botHolder}>
            <div className={styles.infoBox + " " + styles.fLarge + " " + styles.bMedium}>
              <div className={styles.infoTop + " " + styles.fLarge} style={{ color: color }}>
                {processMissed < 0 ? Math.round(Math.abs(processMissed * 100)) + "% more" : processed + "%"}
              </div>
              <div className={styles.infoBottom + " " + styles.fMedium} style={{ background: color, border: border }}>
                {processMissed < 0 ? "Needs to be added" : "Can be reallocated"}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderVariables() {
    const { model, modelFeatures, featureChart } = this.props;

    return (
      <div
        className={styles.features}
        style={{
          opacity: model.featureInfo && model.featureInfo.length > 0 ? 1 : 0.5
        }}
      >
        <div className={styles.predictionBox}>
          <div className={styles.chartHolder}>{featureChart}</div>
        </div>
      </div>
    );
  }

  renderDeploy() {
    const { deployContainer } = this.props;

    return (
      <div className={styles.deployHolder} style={{ height: deployContainer ? "400px" : "0px" }}>
        {deployContainer && deployContainer}
      </div>
    );
  }

  renderButtons() {
    const {
      model,
      updateDeploy,
      cloudURL,
      isContinuous,
      setupChanged,
      testPredict,
      isDone,
      handleCancel,
      handleDelete,
      showDeploy,
      updateShowDeploy,
      initJob
    } = this.props;

    return (
      <div className={styles.buttonHolder}>
        <Button
          type="secondary"
          onClick={() => initJob()}
          disabled={!setupChanged}
          className={styles.wizardButtons}
          style={{ marginRight: "20px" }}
        >
          {"Create New Run"}
        </Button>
        {/*
        <Button
          type="secondary"
          onClick={() => updateDeploy(model.id)}
          disabled={model === undefined}
          className={styles.wizardButtons}
          style={{ marginRight: "20px" }}
        >
          {"Score Data"}
        </Button>
        <Button
          type="secondary"
          onClick={() => updateDeploy(model.id)}
          className={styles.wizardButtons}
          disabled={model === undefined}
        >
          {"Publish"}
        </Button>
        */}
        {isEnabled("deploy") && (
          <Button
            type="primary"
            onClick={() => updateShowDeploy(!showDeploy)}
            className={styles.wizardButtons}
            style={{ marginRight: "20px" }}
          >
            {"Deploy"}
          </Button>
        )}
        {isEnabled("scoring") && (
          <Button
            type="secondary"
            onClick={() => updateDeploy(model.id)}
            disabled={model === undefined}
            className={styles.wizardButtons}
            style={{ marginRight: "20px" }}
          >
            {"Score Data"}
          </Button>
        )}
        <Button
          type="secondary"
          onClick={() => window.open(cloudURL, "_blank")}
          className={styles.wizardButtons}
          disabled={cloudURL === undefined}
        >
          {"Publish"}
        </Button>
      </div>
    );
  }

  renderGraph() {
    const { isContinuous, runPlot } = this.props;
    const { showGraph } = this.state;

    return (
      <div>
        <div className={styles.details}>
          <a style={{ visibility: "hidden" }} onClick={() => this.setState({ showGraph: !showGraph })}>
            {showGraph ? "Hide Details" : "See Details"}
          </a>
        </div>
        <div className={isContinuous ? styles.cGraph : styles.graph} style={{ height: showGraph ? "50vh" : "0px" }}>
          {runPlot}
        </div>
      </div>
    );
  }

  renderGraphBox() {
    const { isContinuous, modelTiles, runPlot } = this.props;

    return (
      <div className={isContinuous ? styles.cGraph : styles.graph} style={{ height: "50vh" }}>
        <div className={styles.modelList} id="modelList">
          {modelTiles}
        </div>
        <div className={styles.gHolder}>{runPlot}</div>
      </div>
    );
  }

  renderDeployment() {
    const { deployment, model, handleRestfulDeploy, stopDeploy } = this.props;

    return (
      <div className={styles.deployment}>
        {!deployment && model && (
          <div className={styles.dHolder}>
            <div>{"Deploy " + model.id}</div>
            <div>
              <Button style={{ marginLeft: "10px" }} onClick={() => handleRestfulDeploy(model.id)} type="primary">
                {"Deploy"}
              </Button>
            </div>
          </div>
        )}
        {deployment && model && deployment.endpoint_url && (
          <div className={styles.dHolder}>
            <div>{model.id + " has been deployed"}</div>
            <Button type="secondary" style={{ marginLeft: "10px" }} onClick={() => stopDeploy(deployment.id)}>
              {"Stop"}
            </Button>
          </div>
        )}
        {deployment && deployment.status === "ERROR" && (
          <div className={styles.dHolder}>
            <div>{model.id + " has errored on deployment"}</div>
            <Button type="secondary" style={{ marginLeft: "10px" }} onClick={() => stopDeploy(deployment.id)}>
              {"Stop"}
            </Button>
          </div>
        )}
        {deployment && deployment.status !== "RUNNING" && deployment.status !== "ERROR" && (
          <div className={styles.dHolder}>
            <div>{"Deploying..."}</div>
            <Button type="secondary" style={{ marginLeft: "10px" }} onClick={() => stopDeploy(deployment.id)}>
              {"Stop"}
            </Button>
          </div>
        )}
        {deployment && (
          <div className={styles.dTile}>
            <DeploymentItem data={deployment} isTile noClick />
          </div>
        )}
      </div>
    );
  }

  render() {
    const { model } = this.props;

    return (
      <div className={styles.resultsWrapper}>
        <div className={styles.modelLabel}>{model.label}</div>
        {this.renderImprovement()}
        {this.renderNext()}
      </div>
    );
  }
}
